import * as React from 'react';
import * as styles from './styles.css';
export var FormFieldGroupLayout = function FormFieldGroupLayout(_ref) {
  var content = _ref.content,
    buttons = _ref.buttons;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles['cont']
  }, content), buttons && /*#__PURE__*/React.createElement("div", {
    className: styles['buttons']
  }, buttons));
};